import { Helmet } from 'react-helmet-async'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import LoadingBox from '../../components/LoadingBox'
import MessageBox from '../../components/MessageBox'
import { useGetAllUsers } from '../../hooks/userHooks'
import { getError } from '../../utils'
import {
  Button,
  Container,
  Pagination,
  PaginationItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'

export default function UserListPage() {
  const navigate = useNavigate()

  const { search } = useLocation()
  const sp = new URLSearchParams(search)
  const page = (() => {
    try {
      const p = sp.get('page')
      return p ? Number(p) : 1
    } catch (e) {
      return 1
    }
  })()

  const { data: responseUsers, isLoading, error } = useGetAllUsers(page)

  return (
    <div>
      <Helmet>
        <title>Visnu EC - ユーザ管理</title>
      </Helmet>
      <Container maxWidth="md" sx={{ py: 5 }}>
        <h1>ユーザ管理</h1>
        <Stack gap={3}>
          {isLoading ? (
            <LoadingBox></LoadingBox>
          ) : error ? (
            <MessageBox variant="danger">{getError(error)}</MessageBox>
          ) : (
            <Stack gap={2}>
              <Typography>ユーザ数： {responseUsers?.countUsers}</Typography>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>メール</TableCell>
                    <TableCell>管理者</TableCell>
                    <TableCell>操作</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {responseUsers.users.map((user) => (
                    <TableRow key={user._id}>
                      <TableCell>{user._id}</TableCell>
                      <TableCell>{user.email}</TableCell>
                      <TableCell>{user.checkAdmin ? '管理者' : '一般'}</TableCell>
                      <TableCell>
                        <Button type="button" onClick={() => navigate(`/admin/user/${user._id}`)}>
                          編集
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>

              <Stack direction={'row'} gap={2} justifyContent={'center'}>
                <Pagination
                  page={page}
                  count={responseUsers?.pages}
                  renderItem={(item) => (
                    <PaginationItem component={Link} to={`/admin/userlist?page=${item.page}`} {...item} />
                  )}
                />
              </Stack>
            </Stack>
          )}
        </Stack>
      </Container>
    </div>
  )
}
